export interface Skill {
    icon: string;
    title: string;
    description: string;
}

export interface Achievement {
    content: string;
}

export interface Achievements {
    academic: Achievement[];
    university: Achievement[];
    software: string[];
}

export interface AboutData {
    title: string;
    subtitle: string;
    skills: Skill[];
    achievements: Achievements;
}

export const aboutData: AboutData = {
    title: 'About Me',
    subtitle:
        'A passionate Computer Scientist with a track record of academic excellence and practical achievements in software development.',

    skills: [
        {
            icon: '👥',
            title: 'Teamwork',
            description:
                'I have participated in multiple team projects, working with other developers and students to create working software. I excel at collaborative problem-solving, code reviews, and ensuring team cohesion while delivering high-quality solutions.',
        },
        {
            icon: '🎯',
            title: 'Leadership',
            description:
                'Having led multiple team projects at work, I understand how important leadership skills are. I have hosted technical presentations, facilitated productive discussions, and resolved team conflicts while maintaining focus on project objectives and team morale.',
        },
        {
            icon: '⚡',
            title: 'Determined',
            description:
                'I am determined to solve problems that I am challenged with, using any resource available to find the solution and actively learning in the process. I thrive on complex challenges and consistently push through obstacles to deliver results.',
        },
    ],

    achievements: {
        academic: [
            {
                content: 'A* (Mathematics), A* (Biology), A (Chemistry) - Mill Hill County High School, 2017',
            },
            {
                content: "First Class Honours, BSc Computer Science - King's College London, 2020",
            },
        ],
        university: [
            {
                content: "1st place, Course-wide programming assignment - King's College London, 2018",
            },
            {
                content: "1st place, Group project competition - King's College London, 2019",
            },
        ],
        software: ['Over 1.6m downloads on software'],
    },
};
